import React, { useState } from "react";
import { Menu } from "lucide-react";
import { Outlet } from "react-router-dom";
import CrmSidebar from "./components/CrmSidebar";
import GlobalSearch from "./components/GlobalSearch";
import LeadNotifier from "./components/LeadNotifier";

export default function CrmLayout() {
  const [sidebar, setSidebar] = useState(false);
  return (
    <div className="min-h-screen bg-[#08080b] text-white flex" data-testid="crm-layout">
      <CrmSidebar open={sidebar} onClose={() => setSidebar(false)} />
      <div className="flex-1 min-w-0 flex flex-col">
        {/* Top bar */}
        <header className="sticky top-0 z-30 bg-[#0a0a0d]/90 backdrop-blur border-b border-white/10 px-4 md:px-6 py-3 flex items-center gap-3">
          <button
            data-testid="crm-menu-toggle"
            onClick={() => setSidebar(true)}
            className="lg:hidden p-2 -ml-2 text-white/70 hover:text-white rounded-lg hover:bg-white/5"
          >
            <Menu className="w-5 h-5" />
          </button>
          <div className="flex-1">
            <GlobalSearch />
          </div>
          <LeadNotifier />
        </header>
        <main className="flex-1 min-w-0">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
